// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"78400a36","281":"d2a69fec","403":"f764a30a","508":"f8889482","530":"4dcdbdc3","638":"78b942dc","706":"d0baf485","719":"a65e6cd7","782":"aced68ff","787":"169a2284","959":"aefa13af","994":"7b9d6416"}[chunkId] + ".chunk.js";
};